(function (window, document) {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'Y82iFT';
  var KLAVIYO_LIST_ID = 'QZ6gp8';
  var KLAVIYO_REVISION = '2026-07-15';

  if (!window.thrvKlaviyoSubscribe) {
    window.thrvKlaviyoSubscribe = async function (options) {
      var email = String(options && options.email || '').trim();
      var source = String(options && options.source || '2THRV website');
      var properties = Object.assign({}, options && options.properties || {});

      if (!email || email.indexOf('@') < 1) {
        throw new Error('invalid_email');
      }

      properties['Signup URL'] = window.location.pathname;
      properties['Signup Timestamp'] = new Date().toISOString();

      var response = await window.fetch(
        'https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID),
        {
          method: 'POST',
          headers: {
            'content-type': 'application/vnd.api+json',
            'revision': KLAVIYO_REVISION
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: source,
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      properties: properties,
                      subscriptions: {
                        email: { marketing: { consent: 'SUBSCRIBED' } }
                      }
                    }
                  }
                }
              },
              relationships: {
                list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
              }
            }
          })
        }
      );

      if (!response.ok) {
        var details = '';
        try { details = await response.text(); } catch (readError) {}
        throw new Error('klaviyo_signup_failed_' + response.status + (details ? '_' + details.slice(0, 160) : ''));
      }

      return true;
    };
  }

  function removeMalformedReferral(link) {
    var raw = link.getAttribute('href');
    if (!raw || raw.indexOf('ref=') === -1) return;

    try {
      var url = new URL(raw, window.location.href);
      var ref = url.searchParams.get('ref');
      if (!ref) return;

      var decoded = decodeURIComponent(ref.replace(/\+/g, ' '));
      var malformed = decoded.indexOf('{{') !== -1 ||
        decoded.indexOf('}}') !== -1 ||
        decoded.indexOf('person|lookup') !== -1 ||
        decoded.indexOf('founder_referral_code') !== -1;

      if (!malformed) return;

      url.searchParams.delete('ref');
      link.setAttribute('href', url.toString());
    } catch (urlError) {}
  }

  function sanitizeMalformedReferralLinks(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('a[href*="ref="]')) removeMalformedReferral(root);
    root.querySelectorAll('a[href*="ref="]').forEach(removeMalformedReferral);
  }

  function bootReferralGuard() {
    sanitizeMalformedReferralLinks(document);
    [250, 750, 1500, 3000].forEach(function (delay) {
      window.setTimeout(function () { sanitizeMalformedReferralLinks(document); }, delay);
    });

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') removeMalformedReferral(mutation.target);
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) sanitizeMalformedReferralLinks(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootReferralGuard, { once: true });
  } else {
    bootReferralGuard();
  }
})(window, document);
